import styled from '@mui/material/styles/styled';
import Skeleton from '@mui/material/Skeleton';

export const StyledSkeleton = styled((props) => (
  <Skeleton {...props} />
))({
  transform: 'scale(1)',
  height: 14,
});